module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_store_badge_android_50-9b49359ba06cd872ff0e1e89b2ed9b6b.png";